import { ReactNode } from 'react';

import classNames from 'classnames';

import { formatDateNumeric } from '@datetime';
import { setupForDark } from '@theme';

export function UserCardDateBadge({ date }: { date: string }) {
  return (
    <div
      className={classNames(
        'P4R flex justify-center items-center gap-none px-xs rounded-xxxl border',
        setupForDark('text-secondary border-text-primary')
      )}
    >
      {formatDateNumeric(date)}
    </div>
  );
}

export default function UserCardShell({
  children,
  onClick,
  'data-testid': dataTestId
}: {
  children: ReactNode;
  onClick?: () => void;
  'data-testid'?: string;
}) {
  return (
    <div
      data-testid={dataTestId}
      className={classNames(
        'flex flex-col gap-sm p-sm rounded-xs border min-w-[196px] max-w-[366px] min-h-[110px] w-full',
        setupForDark('bg-secondary border-primary'),
        onClick && 'cursor-pointer'
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
}
